import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ServicesService } from 'src/services/services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

export interface DirectoryData {
  image_name: any
}

@Component({
  selector: 'app-editgallery',
  templateUrl: './editgallery.component.html',
  styleUrls: ['./editgallery.component.scss']
})
export class EditgalleryComponent {
  labhData: any[] = [];
  gallery_id!: number;
  img_id: any;
  name!: string;
  namee!: String;
  directory_type!: string;
  fathername!: string;
  surname!: string;
  address!: string;
  contact!: number;
  image: any;
  lab_image: any;
  email: any;
  website: any;
  lab_type!: string;
  message!: string;
  imagefileURL!: any | ArrayBuffer;
  imgType!: any | ArrayBuffer;
  imagePath: any; logoPath: any;
  isOld1 = false;
  project = false;
  title: any;
  description: any;
  image_name: any;
  responseArray: any[] = [];
  event_id: any;
  thumb_id: any;
  ELEMENT_DATA: any[] = [];
  isLoading: boolean = false;
  inqires: any;
  dataSource!: MatTableDataSource<DirectoryData>;
  constructor(private service: ServicesService,
    private router: Router,
    public route: ActivatedRoute,
    private toastr: ToastrService) { }


  ngOnInit(): void {
    this.gallery_id = this.route.snapshot.params['gallery_id'];
    this.event_id = this.route.snapshot.params['event_id'] || sessionStorage.getItem('Event_ID');
    this.getGalleryById(this.gallery_id);
  }

  previewpimage(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.service.uploadimage(this.imagefileURL, this.event_id + "/gallery").subscribe((data: any) => {
        this.imagePath = data['image_name'];
        this.isOld1 = false;
      });
    };
  }

  getGalleryById(gallery_id: any) {
    this.labhData = [];
    this.service.getGalleryById(gallery_id, this.event_id).subscribe(
      (data: any) => {
        this.labhData.push(data);
        this.gallery_id = data['data']['0']['gallery_id'];
        this.title = data['data']['0']['title'];
        this.event_id = data['data']['0']['event_id'];
        this.description = data['data']['0']['description'];
        this.image_name = data['data']['0']['image_name'];
        this.thumb_id = data['data']['0']['thumb_id'];
        this.isOld1 = true;

        this.getImagebyId(this.gallery_id, this.event_id);
      },
      (error: any) => {
      }
    );
  }

  getImagebyId(gallery_id: any, event_id: any) {

    this.ELEMENT_DATA = [];
    this.service.getimagebyid(gallery_id, event_id).subscribe(
      (data: any) => {
        this.isLoading = false;
        this.inqires = data['data'];
        for (const item of this.inqires) {
          this.ELEMENT_DATA.push({
            image_name: item.image_name,
            img_id: item.img_id
          });
        }
      },
      (error: any) => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  updateImage() {
    const editlabhData = {
      gallery_id: this.gallery_id,
      event_id: this.event_id,
      description: this.description,
      title: this.title,
      thumb_id: this.thumb_id
    };
    this.service.editGallery(editlabhData).subscribe(
      () => {
        this.toastr.success('EDIT GALLERY SUCCESSFULLY');
        this.router.navigate([`/admin/gallery`]);
      });
  }

  addimage() {
    console.log(this.imagePath);

    if (!this.imagePath || this.imagePath.length === 0) {
      this.toastr.error('Please select an image');
      return;
    }
    const labhArray = {
      event_id: this.event_id,
      gallery_id: this.gallery_id,
      image_name: this.imagePath
    };
    this.service.Addimage(labhArray).subscribe(
      () => {
        window.location.reload();
      },
    );
  }

  deleteimage(img_id: number) {
    const buttonClicked = window.confirm('Are You Want To Sure Delete This Image');
    if (buttonClicked === true) {
      this.service.Deleteimage(this.event_id, img_id).subscribe(
        () => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.img_id !== img_id);
          this.inqires = this.ELEMENT_DATA;
          this.toastr.success('GALLERY DELETED SUCCESSFULLY');
        });
    }
  }
}
